import AdminGridKendo from "./AdminGridKendo";

export const columnTypes = {
  actions: "Actions",
  checkbox: "Checkbox",
  boolean: "Boolean",
  radioButton: "RadioButton",
};

export const direction = {
  ASC: "asc",
  DESC: "desc",
};

export default function AdminGrid(props) {
  return <AdminGridKendo {...props} />;
}
